import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatIconModule, MatPaginatorModule, MatSnackBarModule, MatTableModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { FuseProgressBarModule, FuseSidebarModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { AppComponent } from 'app/app.component';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import 'hammerjs';
import { LoaderModule } from './main/shared/components/loader/loader.module';
import { AppGuard } from './main/shared/guards/app.guard';
import { LoaderService } from './main/shared/services/loaderService.service';
import { SharedModule } from './main/shared/shared.module';
import { PoliciesGuard } from './main/shared/guards/policies.guard';
registerLocaleData(localeIt);

const appRoutes: Routes = [
    {
        path: 'public-area',
        loadChildren: './main/pages/public-area/public-area.module#PublicAreaModule'
    },
    {
        path: 'administration-area',
        loadChildren: './main/pages/administration-area/admin.module#AdminModule',
        canActivate: [AppGuard]
    },
    {
        path: 'users-area',
        loadChildren: './main/pages/users-area/users-area.module#UsersAreaModule',
        canActivate: [PoliciesGuard, AppGuard]
    },
    {
        path: 'common-area',
        loadChildren: './main/pages/common-area/common-area.module#CommonAreaModule',
        canActivate: [PoliciesGuard, AppGuard]
    },
    {
        path: 'best-match-area',
        loadChildren: './main/pages/best-match-area/best-match.module#BestMatchModule'
    },
    {
        path: '',
        redirectTo: '/public-area/redirect',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/public-area/error-404',
        pathMatch: 'full'
    },
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        LoaderModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        RouterModule.forRoot(appRoutes),

        // Material
        MatButtonModule,
        MatIconModule,
        MatPaginatorModule,
        MatTableModule,
        MatSnackBarModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,

        // App modules
        LayoutModule,

        // Shared
        SharedModule,
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        LoaderService
    ]
})
export class AppModule {

}
